/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { toast } from 'react-toastify'
import Contenedor from '../../Components/Contenedor/Contenedor'
import NewButton from '../../Components/Botones/NewButton'
import EditButton from '../../Components/Botones/EditButton'
import DataTable from '../../Components/DataTables'
import NewModal from '../../Components/Modal/NewModal'
import { getRequest, postRequest } from '../../utils/requester'
import './style.css'
/*import Can from '../../Utils/Funciones/can'*/

function Campus() {
  const [dataInicial, setDataInicial] = useState([])
  const [dataFiltradas, setDataFiltradas] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingModal, setLoadingModal] = useState(false)
  const [loadingModalEditar, setLoadingModalEditar] = useState(false)
  const [modalEditarIsOpen, setModalEditarIsOpen] = useState(false)
  const [modalNuevaIsOpen, setModalNuevaIsOpen] = useState(false)
  const [nueva, setNueva] = useState({
    nombre: '',
    descripcion: '',
    status: 'activa',
  })
  const [editar, setEditar] = useState({
    clave: '',
    nombre: '',
    agrupador: '',
  })
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteModalLoading, setDeleteModalLoading] = useState(false)

  const openEditModal = async (id, clave, nombre, grupo) => {
    setEditar({
      id,
      clave,
      nombre,
      grupo,
    })
    setModalEditarIsOpen(true)
  }

  const handleEditar = async (data) => {
    if (validar(data)) {
      setLoadingModalEditar(true)
      try {
        const { id, grupo } = data
        const response = await postRequest('/campus/editar', {
          id,
          grupo,
        })
        if (response.s === 'OK') {
          toast.success(response.m)
          setModalEditarIsOpen(false)
          setLoadingModalEditar(false)
          reloadList()
        }
        setLoadingModalEditar(false)
      } catch (error) {
        console.error(error)
        setLoadingModalEditar(false)
      }
    }
  }

  const handleNueva = async (data) => {
    if (validar(data)) {
      try {
        setLoadingModal(true)
        console.log(data)
        //const nuevaEtiquetaResponse = await postRequest(`/etiqueta/nueva`, data);
        const nuevaResponse = nueva()
        if (nuevaResponse.s === 'OK') {
          setLoadingModal(false)
          setModalNuevaIsOpen(false)
          reloadList()
        }
        setLoadingModal(false)
      } catch (error) {
        console.error(error)
        setLoadingModal(false)
      }
    }
  }

  const validar = (body) => {
    let valido = true
    if (body.nombre === '') {
      document.getElementById('tag-nombre').classList.add('error')
      valido = false
    } else {
      document.getElementById('tag-nombre').classList.remove('error')
    }
    if (body.grupo === '' && body.grupo.length > 50) {
      document.getElementById('tag-descripcion').classList.add('error')
      valido = false
    } else {
      document.getElementById('tag-descripcion').classList.remove('error')
    }
    return valido
  }

  const handleDelete = async () => {
    setDeleteModalLoading(true)
    try {
      /*
      const eliminarEtiquetaResponse = await postRequest(`/etiqueta/eliminar`, {
        id: etiquetaEditar.id,
      });
      */
      const eliminarResponse = eliminar()
      if (eliminarResponse.s === 'OK') {
        setModalEditarIsOpen(false)
        setDeleteModalLoading(false)
        reloadList()
        setDeleteModal(false)
      }
      setDeleteModal(false)
      setDeleteModalLoading(false)
    } catch (error) {
      console.error(error)
      setDeleteModal(false)
      setDeleteModalLoading(false)
    }
  }

  const testHeader = ['Clave', 'Nombre', 'Agrupador', 'Acciones']

  ////////// Filtrar resultados segun el input de busqueda //////////
  const search = (e) => {
    let text = e.target.value.toLowerCase()

    let result = dataInicial.filter((row) => {
      if (row[0].toString().toLowerCase().includes(text)) return true
      else if (row[1].toLowerCase().includes(text)) return true
      return false
    })
    setDataFiltradas(result)
  }

  const reloadList = async () => {
    setLoading(true)
    try {
      //const responseEtiqueta = await getRequest('/etiqueta');
      const response = await getRegs()
      if (response.s === 'OK') {
        let data = []
        response.d.forEach((reg) => {
          data.push([
            reg.clave,
            reg.nombre,
            reg.agrupador,
            <EditButton
              onClick={(e) =>
                openEditModal(reg.id, reg.clave, reg.nombre, reg.agrupador)
              }
            >
              Editar
            </EditButton>,
          ])
        })
        setDataInicial(data)
        setDataFiltradas(data)
        setLoading(false)
      } else {
        setLoading(false)
      }
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    reloadList()
  }, [])

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: '#616b74',
      fontSize: 14,
      fontWeight: 400,
      padding: '5px 25px',
      cursor: 'pointer',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      userSelect: 'none',
      backgroundColor: '#fff',
      borderTop: '1px solid #ccc',
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: 0,
      height: '25px',
      borderRadius: 15,
      fontSize: 11,
      backgroundColor: '#f9f9f9',
      padding: 0,
    }),
    placeholder: (provided, state) => ({
      ...provided,
      padding: 0,
      fontSize: 11,
      fontWeight: 400,
    }),
    menu: (provided, state) => ({
      ...provided,
      borderRadius: 0,
    }),
    input: (provided, state) => ({
      ...provided,
      padding: 0,
      fontSize: 11,
      fontWeight: 400,
      borderRadius: 0,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      top: '50%',
    }),
  }
  return (
    <Contenedor title='Campus'>
      <div className='opciones-bar'>
        <div className='sub-filtro'></div>
        <div style={{ float: 'right', marginTop: '30px' }}>
          <input
            type='search'
            placeholder='Buscar'
            className='SearchInput-tabla-completa SearchInput-Usuarios'
            onChange={search}
          />
        </div>
      </div>
      <div style={{ height: 'calc(100% - 70px)' }}>
        <DataTable
          headers={testHeader}
          data={dataFiltradas}
          loading={loading}
          paginate
        />
      </div>
      <NewModal
        title='Editar Campus'
        open={modalEditarIsOpen}
        handleClose={() => setModalEditarIsOpen(false)}
        height={320}
        width={500}
        loading={loadingModalEditar}
        handleSubmit={() => handleEditar(editar)}
        permiso='campus'
      >
        <div
          ref={(el) => el && el.style.setProperty('height', '85%', 'important')}
          className='nuevoEtiquetaForm'
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <label id='tag-nombre'>Clave (*):</label>
              <input
                style={{ textAlign: 'center' }}
                disabled
                placeholder='Ingresa Clave'
                value={editar.clave}
                onChange={(e) =>
                  setEditar({
                    ...editar,
                    clave: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <label id='tag-descripcion'>Nombre (*):</label>
              <input
                style={{ textAlign: 'center' }}
                disabled
                placeholder='Ingresa Nombre'
                value={editar.nombre}
                onChange={(e) =>
                  setEditar({
                    ...editar,
                    nombre: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <label id='tag-descripcion'>Grupo (*):</label>
              <input
                style={{ textAlign: 'center' }}
                placeholder='Ingresa Grupo'
                value={editar.grupo}
                onChange={(e) =>
                  setEditar({
                    ...editar,
                    grupo: e.target.value,
                  })
                }
              />
            </Grid>
          </Grid>
        </div>
      </NewModal>
      <NewModal
        open={deleteModal}
        height={120}
        title='Confirmar'
        loading={deleteModalLoading}
        handleClose={() => setDeleteModal(false)}
        handleSubmit={handleDelete}
      >
        <div class='delete-confirm'>
          <h2 style={{ textAlign: 'center' }}>
            ¿Está seguro de que desea eliminar esta etiqueta?
          </h2>
        </div>
      </NewModal>
    </Contenedor>
  )
}
const mapStateToProps = (state) => {
  return {
    //isLoged: state.isLoged,
  }
}

const mapDispatchToProps = {
  //setIsLoged
}

export default connect(mapStateToProps, mapDispatchToProps)(Campus)

// Get campus list
async function getRegs() {
  try {
    const response = await getRequest('/campus')
    return response
  } catch (error) {
    console.log(error)
  }

  // return({"s":"OK","m":"Lista de etiquetas encontrada","d":[{"id":29,clave:'OP1',"nombre":"OE2020_ExpDis","descripcion":"Experto en disciplinas (Instrumento 2020)"},{"id":30,clave:'OP1',"nombre":"OE2020_CenEst","descripcion":"Centrado en el estudiante (Instrumento 2020)"},{"id":31,clave:'OP1',"nombre":"OE2020_DisEdu","descripcion":"Diseño educativo (Instrumento 2020)"},{"id":32,clave:'OP1',"nombre":"OE2020_EtiInt","descripcion":"Ética e integridad (Instrumento 2020)"},{"id":33,clave:'OP1',"nombre":"OE2020_EvaApr","descripcion":"Evaluación del aprendizaje (Instrumento 2020)"},{"id":34,clave:'OP1',"nombre":"OE2020_HabPEA","descripcion":"Habilidades para mediar el proceso enseñanza-aprendizaje (Instrumento 2020)"},{"id":35,clave:'OP1',"nombre":"OE2020_UsoTec","descripcion":"Uso de tecnología (Instrumento 2020)"},{"id":36,clave:'OP1',"nombre":"OE2020_NPS","descripcion":"NPS (Instrumento 2020)"},{"id":37,clave:'OP1',"nombre":"OEBACH2020_SeClas","descripcion":"Secuencia entre clases (Instrumento 2020)\n"},{"id":38,clave:'OP1',"nombre":"OEBACH2020_OptCV","descripcion":"Optimizar la clase virtual (Instrumento 2020)"},{"id":39,clave:'OP1',"nombre":"OEBACH2020_TecDid","descripcion":"Técnicas didácticas (Instrumento 2020)"},{"id":40,clave:'OP1',"nombre":"OEBACH2020_OrgCD","descripcion":"Organización y claridad en el discurso (Instrumento 2020)"},{"id":41,clave:'OP1',"nombre":"OEBACH2020_DomCon","descripcion":"Dominio de los contenidos (Instrumento 2020)"},{"id":42,clave:'OP1',"nombre":"OEBACH2020_AjuClas","descripcion":"Ajuste durante la clase (Instrumento 2020)"},{"id":43,clave:'OP1',"nombre":"OEBACH2020_RetAca","descripcion":"Retroalimentación Académica (Instrumento 2020)"},{"id":44,clave:'OP1',"nombre":"OEBACH2020_GuiaAco","descripcion":"Guía y acompañamiento (Instrumento 2020)"},{"id":45,clave:'OP1',"nombre":"OEBACH2020_UsoPVA","descripcion":"Uso de la plataforma virtual de aprendizaje (Instrumento 2020)"},{"id":46,clave:'OP1',"nombre":"OEBACH2020_ProOriEst","descripcion":"Promoción de un vínculo de orientación con sus estudiantes (Instrumento 2020)"},{"id":47,clave:'OP1',"nombre":"OEBACH2020_ProFilUVM","descripcion":"Promoción de la filosofía educativa UVM (Instrumento 2020)"},{"id":48,clave:'OP1',"nombre":"OEROL2020_ExpDis","descripcion":"Experto en disciplinas (Instrumento 2020)"},{"id":49,clave:'OP1',"nombre":"OEROL2020_CenEst","descripcion":"Centrado en el estudiante (Instrumento 2020)"},{"id":50,clave:'OP1',"nombre":"OEROL2020_DisEdu","descripcion":"Diseño educativo (Instrumento 2020)"},{"id":51,clave:'OP1',"nombre":"OEROL2020_EtiInt","descripcion":"Ética e integridad (Instrumento 2020)"},{"id":52,clave:'OP1',"nombre":"OEROL2020_EvaApr","descripcion":"Evaluación del aprendizaje (Instrumento 2020)"},{"id":53,clave:'OP1',"nombre":"OEROL2020_HabPEA","descripcion":"Habilidades para mediar el proceso enseñanza-aprendizaje (Instrumento 2020)\n"},{"id":55,clave:'OP1',"nombre":"OEROL2020_NPS","descripcion":"NPS (Instrumento 2020)\n"},{"id":56,clave:'OP1',"nombre":"OEROL2020_DisIns","descripcion":"Diseño Instruccional (instrumento 2020)"},{"id":57,clave:'OP1',"nombre":"ESROL2020","descripcion":"Encuesta de Servicio (instrumento 2020)"}]})
}
function nueva() {
  return { s: 'OK', m: 'etiqueta creada correctamente', d: 58 }
}

// Edit a specific campus
async function editar(id, grupo) {
  try {
    const response = await postRequest('/campus/editar', {
      id,
      grupo,
    })
    return response
  } catch (error) {
    console.log(error)
  }
}
function eliminar() {
  return { s: 'OK', m: 'etiqueta eliminada correctamente', d: '' }
}
